const updates = [
  {
    id: 1,
    date: '2026-07-28',
    title: '《剑与魔法》第217话更新',
    desc: '少年剑士终于迎来了与最终Boss的正面对决，本话战斗分镜堪称韩漫史上最强作画。',
    tag: '刚刚更新',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    id: 2,
    date: '2026-07-28',
    title: '《命运轮回》第341话上线',
    desc: '主角觉醒隐藏技能，前世记忆完全解封，异世界格局即将迎来天翻地覆的变化。',
    tag: '2小时前',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    id: 3,
    date: '2026-07-27',
    title: 'YY漫画新增夜间阅读模式',
    desc: '护眼夜间模式正式上线，自动调节亮度和色温，深夜看漫画再也不伤眼。',
    tag: '功能更新',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    id: 4,
    date: '2026-07-27',
    title: '《暗夜追踪者》第153话发布',
    desc: '侦探终于发现了幕后黑手的关键线索，但危险也在一步步逼近，悬念层层升级。',
    tag: '昨日更新',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    id: 5,
    date: '2026-07-26',
    title: '《甜蜜陷阱》第90话甜蜜来袭',
    desc: '男女主角终于确认关系，甜度爆表的一话，读者评论区已经彻底沦陷。',
    tag: '2天前',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    id: 6,
    date: '2026-07-26',
    title: '平台新增200+部韩漫资源',
    desc: 'YY漫画资源库再扩容，一次性上线超过200部韩国漫画，涵盖热门新番和经典老番。',
    tag: '资源更新',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    id: 7,
    date: '2026-07-25',
    title: '《拳皇之路》第199话燃爆全场',
    desc: '总决赛进入白热化阶段，主角以一敌三的逆天表现让读者直呼过瘾，评论区热烈讨论中。',
    tag: '3天前',
    tagColor: 'bg-primary-100 text-primary-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-22 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            最新动态
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            漫画更新与平台动态一手掌握
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-300">
            {updates.map((item, index) => (
              <div
                key={item.id}
                className={`relative pb-8 ${index === updates.length - 1 ? 'pb-0' : ''}`}
              >
                <div className="absolute -left-[25px] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>

                <div className="bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
                  <div className="flex items-center gap-3 flex-wrap mb-2">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded text-xs font-bold ${item.tagColor} whitespace-nowrap`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-base text-foreground-900">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}